var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['highlight', { 'is-primary': _vm.isPrimary }],style:(_vm.styles),attrs:{"title":_vm.infoLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }